import { Box, Button, Stack, Typography, useTheme } from '@mui/material';

import { ICareLinkRequest } from './types';

interface CareLinkRequestProps {
  data: ICareLinkRequest;
  onAcceptRequest: (id: string) => void;
}

export const CareLinkRequest = ({
  data,
  onAcceptRequest,
}: CareLinkRequestProps) => {
  const theme = useTheme();

  return (
    <Stack
      spacing={2}
      padding={2}
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.shape.borderRadius,
      }}
    >
      <Box>
        <Typography fontSize={14} fontWeight={500}>
          {data.location.name}
        </Typography>
        <Typography fontSize={14}> {data.location.address}</Typography>
      </Box>
      <Box>
        <Typography fontSize={12}>Incident code</Typography>
        <Typography fontSize={14} fontWeight={500}>
          {data.incidentCode}
        </Typography>
      </Box>
      <Box>
        <Typography fontSize={12}>Short description</Typography>
        <Typography fontSize={14} fontWeight={500}>
          {data.description}
        </Typography>
      </Box>
      <Button
        variant="contained"
        color="error"
        sx={{ my: 2 }}
        fullWidth
        onClick={() => {
          onAcceptRequest(data.id);
        }}
      >
        Accept
      </Button>
    </Stack>
  );
};
